
define('text!views/shared/tab/tab_component.html',[],function () { return '<div class="tab-component">\r\n\t\t\t\t\r\n\t<ul class="tabs js-tabs"></ul>\r\n\r\n\t<div class="tab-content js-tab-content"></div>\r\n\r\n</div>';});

